import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import type { SignInWithAppleNativeApplePlugin } from './definitions';
import { CAPACITOR_SIGN_IN_WITH_APPLE_NATIVE_APPLE_PLUGIN_NAME } from '../pluginConstants';

const SignInWithAppleNativeAppleRaw = registerPlugin<SignInWithAppleNativeApplePlugin>(
    CAPACITOR_SIGN_IN_WITH_APPLE_NATIVE_APPLE_PLUGIN_NAME,
);
const SignInWithAppleNativeApple = withBridgedStackTrace(
    SignInWithAppleNativeAppleRaw,
    CAPACITOR_SIGN_IN_WITH_APPLE_NATIVE_APPLE_PLUGIN_NAME,
);

export * from './definitions';
export { SignInWithAppleNativeApple };
